
import "../whatsAppButton/WhatsAppButton.css";

const WhatsAppButton = () => {
  const phone = "5218126007799";
  const message = "Hola, necesito ayuda para completar mi registro.";

  const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <div className="whatsapp-container">
      <a
        href={whatsappUrl}
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contactar por WhatsApp"
        aria-describedby="whatsapp-tooltip"
      >
        <span id="whatsapp-tooltip" className="whatsapp-tooltip" role="tooltip">
          Contactar con un representante
        </span>
        <svg
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M16.01 3C8.83 3 3 8.82 3 16c0 2.3.6 4.55 1.73 6.54L3.04 29l6.6-1.65A12.94 12.94 0 0 0 16 29c7.18 0 13-5.82 13-13S23.19 3 16.01 3Zm0 23.8c-2.04 0-4.04-.55-5.8-1.6l-.42-.25-3.92.98 1.05-3.82-.27-.43A10.73 10.73 0 1 1 16.01 26.8Zm5.88-8.04c-.32-.16-1.9-.94-2.2-1.05-.3-.11-.52-.16-.74.16-.22.33-.85 1.05-1.04 1.27-.19.22-.38.25-.7.08-.32-.16-1.36-.5-2.59-1.6-.96-.85-1.61-1.9-1.8-2.22-.19-.33-.02-.5.14-.66.15-.15.32-.38.49-.57.16-.19.22-.33.33-.55.11-.22.05-.41-.03-.57-.08-.16-.74-1.78-1.01-2.44-.27-.64-.54-.55-.74-.56h-.63c-.22 0-.57.08-.87.41-.3.33-1.14 1.11-1.14 2.7s1.17 3.13 1.33 3.35c.16.22 2.3 3.51 5.58 4.92.78.34 1.39.54 1.86.69.78.25 1.49.21 2.05.13.63-.09 1.9-.78 2.17-1.54.27-.76.27-1.41.19-1.54-.08-.14-.3-.22-.62-.38Z"
            fill="currentColor"
          />
        </svg>
      </a>
    </div>
  );
};

export default WhatsAppButton;
